<template>
    <div>
        <div class="resultPage" v-if="userStatus === '0' || userStatus === '1'">
            <div>
                <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;" v-if="userStatus === '0'">
                    <div>
                        <van-icon name="clock-o" size="2rem" color="#999"/>
                    </div>
                    <div>
                        <span style="color:#777;display: block;margin: 1rem;">{{userDescribe}}</span>
                    </div>
                </div>
                <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;" v-if="userStatus === '1'">
                    <div>
                        <van-icon name="certificate" size="2rem" color="#696"/>
                    </div>
                    <div>
                        <span style="color: #777;display: block;margin: 1rem;">{{userDescribe}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="userStatus === '2' || userStatus === '3' || userStatus === '99'">
            <van-cell-group title="用户认证">
                <van-cell title="选择您的车辆用途">
                    <template #label>
                        <span>我们将为您填写的信息，打造最合适的服务</span><br>
                        <span>在'个人信息-车主认证'里可以更改设置</span><br>
                        <span v-if="userStatus === '2'" style="color:#d32;">您的上次提交过审失败，请重新确提交认证</span><br>
                        <span v-if="userStatus === '2' && userDescribe.length > 0" style="color:#d32;">失败原因：{{userDescribe}}</span><br>
                        <van-grid :border="false" :column-num="3" center>

                            <van-grid-item text="专快车/顺风车" @click="chooseTypeEvent('online_car_hailing')">
                                <div class="squareBox">
                                    <div style="display: inline-block;vertical-align: middle;width: 99%;height: 99%;">
                                        <div style="display: flex;justify-content: center;align-items: center;height: 100%;width: 100%;box-sizing: border-box;" :class="form.auth_type == 'online_car_hailing' ? 'GridSelected' : 'UnGridSelected'">
                                            <van-image
                                            :width="form.auth_type == 'online_car_hailing' ? '80%' : '75%'"
                                            :height="form.auth_type == 'online_car_hailing' ? '80%' : '75%'"
                                            :src="require('../../assets/images/certificat_K.png')"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <span style="margin:0.3rem">专快车/顺风车</span>
                            </van-grid-item>
                            <van-grid-item text="物流车/商用车" @click="chooseTypeEvent('commercial_car')">
                                <div class="squareBox">
                                    <div style="display: inline-block;vertical-align: middle;width: 99%;height: 99%;">
                                        <div style="display: flex;justify-content: center;align-items: center;height: 100%;width: 100%;box-sizing: border-box;" :class="form.auth_type == 'commercial_car' ? 'GridSelected' : 'UnGridSelected'">
                                            <van-image
                                            :width="form.auth_type == 'commercial_car' ? '80%' : '75%'"
                                            :height="form.auth_type == 'commercial_car' ? '80%' : '75%'"
                                            :src="require('../../assets/images/certificat_W.png')"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <span style="margin:0.3rem">物流车/商用车</span>
                            </van-grid-item>
                            <van-grid-item text="出租车" @click="chooseTypeEvent('taxi')">
                                <div class="squareBox">
                                    <div style="display: inline-block;vertical-align: middle;width: 99%;height: 99%;">
                                        <div style="display: flex;justify-content: center;align-items: center;height: 100%;width: 100%;box-sizing: border-box;" :class="form.auth_type == 'taxi' ? 'GridSelected' : 'UnGridSelected'">
                                            <van-image
                                            :width="form.auth_type == 'taxi' ? '80%' : '75%'"
                                            :height="form.auth_type == 'taxi' ? '80%' : '75%'"
                                            :src="require('../../assets/images/certificat_C.png')"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <span style="margin:0.3rem">出租车</span>
                            </van-grid-item>
                            <van-grid-item text="公司团体" @click="chooseTypeEvent('company_group')">
                                <div class="squareBox">
                                    <div style="display: inline-block;vertical-align: middle;width: 99%;height: 99%;">
                                        <div style="display: flex;justify-content: center;align-items: center;height: 100%;width: 100%;box-sizing: border-box;" :class="form.auth_type == 'company_group' ? 'GridSelected' : 'UnGridSelected'">
                                            <van-image
                                                :width="form.auth_type == 'company_group' ? '80%' : '75%'"
                                                :height="form.auth_type == 'company_group' ? '80%' : '75%'"
                                                :src="require('../../assets/images/certificat_Company.png')"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <span style="margin:0.3rem">公司团体</span>
                            </van-grid-item>
                        </van-grid>
                    </template>
                </van-cell>
            </van-cell-group>

            <van-cell-group title="认证信息" v-if="form.auth_type == 'taxi' || form.auth_type == 'commercial_car' || form.auth_type == 'company_group'">
                <van-cell :title="type[form.auth_type]" >
                    <template #label>
                        <span>本次上传仅用于认证，我们将对您上传的信息严格保密</span><br>
                        <span>请填写车牌号码并上传车辆行驶证照片</span><br>
                        <div style="margin-top: 0.5rem">
                            <span class="UploadSpan">输入车牌号</span>
                            <PlateNumberInputer @setNumber="GetPlateNumber"/>
                        </div>

                        <div style="margin-top: 0.5rem">
                            <span class="UploadSpan">上传证件图片</span>
                            <van-uploader v-model="uploadImage[0]" :max-count="1" class="UploadImage" :after-read="imageFrontAfterRead">
                            </van-uploader>
                            <span class="UploadInfo">上传证件主页</span>
                        </div>

                        <div style="margin-top: 0.5rem">
                            <van-uploader v-model="uploadImage[1]" :max-count="1" class="UploadImage" :after-read="imageBackAfterRead">
                            </van-uploader>
                            <span class="UploadInfo">上传证件背页</span>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>

            <van-cell-group title="认证信息" v-if="form.auth_type == 'online_car_hailing'">
                <van-cell title="专快车/顺风车认证" >
                    <template #label>
                        <span>本次上传仅用于认证，我们将对您上传的信息严格保密</span><br>
                        <span>请填写车牌号码并上传平台上包含车牌号的页面截图</span><br>
                        <div style="margin-top: 0.5rem">
                            <span class="UploadSpan">输入车牌号</span>
                            <PlateNumberInputer @setNumber="GetPlateNumber"/>
                        </div>
                        <div style="margin-top: 0.5rem">
                            <span class="UploadSpan">上传平台截图</span>
                            <van-uploader v-model="uploadImage[2]" :max-count="1" class="UploadImage" :after-read="imagePlatformAfterRead">
                            </van-uploader>
                        </div>
                        <div style="margin-top: 0.5rem">
                            <span class="UploadSpan" style="margin-bottom: 0.1rem">选择渠道</span>
                        </div>
                    </template>
                </van-cell>
                <div class="clearLine">
                    <van-cell title="渠道平台" :value="channels.select" is-link @click="showChannelPopup" style="border:1px solid #999; width: 80%; margin: auto;"></van-cell>
                </div>
                <van-popup v-model="channelPopupShow" position="bottom">
                    <van-picker
                    title="标题"
                    show-toolbar
                    :columns="channelColumns"
                    @confirm="channelOnConfirm"
                    @cancel="channelOnCancel"
                    />
                </van-popup>
            </van-cell-group>

            <van-cell title="注意事项" style="padding-top:1rem;">
                <template #label>
                    <span>1.拍摄证件时确保行驶证的边框完整、字体清晰、亮度均匀。</span><br>
                    <span>2.上传平台认证图需上传滴滴/优步平台个人资料中含有车牌号的页面截图。</span><br>
                    <span>3.请确填写的车牌号码与行驶证件车牌号保持一致。</span>
                    <div style="display: flex;justify-content: center;margin:0.6rem 0;">
                        <van-button type="info" class="SubmitBtn" :disabled="form.auth_type === ''" @click="submit">提 交 信 息</van-button>
                    </div>
                </template>
            </van-cell>
        </div>
    </div>
</template>

<script>
    import api from "../../assets/js/api";
    import auth from "../../assets/js/auth";
    import mixin from '../mixin';
    import PlateNumberInputer from "../../components/common/PlateNumberInputer"

    export default {
        name: "Certification",
        components: {PlateNumberInputer},
        mixins: [mixin],
        data() {
            return {
                isLoading: false,
                channelPopupShow: false,
                before: '',
                userStatus: '', //0审核中，1成功，2失败，3过期，99未提交
                userDescribe: '',
                userId: '',
                uploadImage: [[],[],[]],
                imageData:{
                    vehicle_license_front_img: '',
                    vehicle_license_back_img: '',
                    platform_auth_img: ''
                },
                channels: {
                    select: '',
                    '滴滴/优步': 'didi',
                    '曹操出行': 'caocao',
                    '首汽约车': 'shouqi',
                    '神州专车': 'shenzhou',
                    '嘀嗒出行': 'dida',
                    '其他': 'other',
                    didi : '滴滴/优步',
                    caocao : '曹操出行',
                    shouqi : '首汽约车',
                    shenzhou : '神州专车',
                    dida : '嘀嗒出行',
                    other : '其他',
                },
                type: {
                    taxi: '出租车',
                    commercial_car: '物流车/商用车',
                    online_car_hailing: '专快车/私家车',
                    company_group: '公司团体',
                },
                form: {
                    auth_type: '',
                    license_plate_number: '',
                    info: {
                        channel: '',
                        vehicle_license_front_img: '',
                        vehicle_license_back_img: '',
                        platform_auth_img: '',
                    }
                }
            }
        },
        mounted() {
            let that = this;
            api.request('/user/car_auth_status').then(res => {
                if (res.data === '' || res.data === undefined || res.data === null) {
                    that.userStatus = '99';
                } else {
                    that.userStatus = res.data.status;
                    if (res.data.describe) {
                        that.userDescribe = res.data.describe;
                    }
                    if (res.data.status === '2') {
                        that.userId = res.data.id;
                        that.form.auth_type = res.data.auth_type;
                        if (res.data.info.channel) {
                            that.form.info.channel = res.data.info.channel;
                            that.channels.select = that.channelType[res.data.info.channel];
                        }
                    }
                };
            }).catch(err => {
                that.$toast.fail('发生错误');
                that.$router.push({ name : 'User' });
            })
        },
        methods : {
            chooseTypeEvent(type) {
                this.form.auth_type = type;
            },
            GetPlateNumber(num) {
                this.form.license_plate_number = num;
            },
            showChannelPopup() {
                this.channelPopupShow = true;
            },
            channelOnConfirm(value, index) {
                this.channels.select = value;
                this.form.info.channel = this.channelValue[value];
                this.channelPopupShow = false;
            },
            channelOnCancel(value, index) {
                this.channelPopupShow = false;
            },
            submit() {
                let that = this;
                if (this.isLoading) {
                    return
                }
                if (this.userStatus === '2') {
                    this.form.id = this.userId;
                } else {
                    delete this.form.id;
                }
                if (this.form.license_plate_number.length < 6) {
                    this.$notify({ type: 'danger', message: '请输入正确的车牌号码' })
                    return
                }
                if (this.form.auth_type == 'online_car_hailing') {
                    if (this.uploadImage[2].length === 0) {
                        this.$notify({ type: 'danger', message: '请上传对应图片' })
                        return
                    }
                    if (this.channels.select === '') {
                        this.$notify({ type: 'danger', message: '请选择对应的渠道' })
                        return
                    }
                    this.isLoading = true;
                    let loading = that.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        loadingType: 'spinner',
                        duration: 0,
                    });
                    let fromData = new FormData();
                    fromData.append('file', that.imageData.platform_auth_img.file);
                    api.request('/common/image_upload', fromData).then(res => {
                        that.form.info.platform_auth_img = res.data.file.url;
                        delete that.form.info.vehicle_license_front_img;
                        delete that.form.info.vehicle_license_back_img;
                        api.request('/user/car_auth_submit', that.form).then(res => {
                            that.$toast.clear(loading);
                            that.$toast.success('提交完成');
                            that.$router.go(-1);
                        }).catch(err => {
                            that.$toast.clear(loading);
                            that.$toast.fail('提交失败');
                            that.$notify({ type: 'danger', message: err.msg })
                        }).finally(() => {
                            that.isLoading = false;
                        })
                    }).catch(err => {
                        that.$toast.clear(loading);
                        that.$toast.fail('提交失败');
                        that.$notify({ type: 'danger', message: err.msg })
                    })
                }
                if (this.form.auth_type == 'taxi' || this.form.auth_type == 'commercial_car' || this.form.auth_type == 'company_group') {
                    if (this.uploadImage[0].length === 0 || this.uploadImage[1].length === 0) {
                        this.$notify({ type: 'danger', message: '请上传对应图片' })
                        return
                    }
                    this.isLoading = true;
                    let loading = that.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        loadingType: 'spinner',
                        duration: 0,
                    });
                    let fromData = new FormData();
                    fromData.append('file', that.imageData.vehicle_license_front_img.file);
                    let uploadFront = api.request('/common/image_upload', fromData).then(res => {
                        that.form.info.vehicle_license_front_img = res.data.file.url;
                    }).catch(err => {
                        that.$toast.clear(loading);
                        that.$toast.fail('提交失败');
                        that.$notify({ type: 'danger', message: err.msg })
                    })
                    fromData = new FormData();
                    fromData.append('file', that.imageData.vehicle_license_back_img.file);
                    let uploadBack = api.request('/common/image_upload', fromData).then(res => {
                        that.form.info.vehicle_license_back_img = res.data.file.url;
                    }).catch(err => {
                        that.$toast.clear(loading);
                        that.$toast.fail('提交失败');
                        that.$notify({ type: 'danger', message: err.msg })
                    })
                    Promise.all([uploadFront, uploadBack]).then((res) => {
                        that.$nextTick(() => {
                            delete that.form.info.channel;
                            delete that.form.info.platform_auth_img;
                            api.request('/user/car_auth_submit', that.form).then(res => {
                                that.$toast.clear(loading);
                                that.$toast.success('提交完成');
                                that.$router.go(-1);
                            }).catch(err => {
                                that.$toast.clear(loading);
                                that.$toast.fail('提交失败');
                                that.$notify({ type: 'danger', message: err.msg })
                            }).finally(() => {
                                that.isLoading = false;
                            })
                        })
                    })
                }
            },
            imagePlatformAfterRead(file) {
                this.imageData.platform_auth_img = file;
            },
            imageFrontAfterRead(file) {
                this.imageData.vehicle_license_front_img = file;
            },
            imageBackAfterRead(file) {
                this.imageData.vehicle_license_back_img = file;
            }
        },
        computed: {
            channelType: function() {
                return this.$store.state.systemEnum.company.user_car_auth ? this.$store.state.systemEnum.company.user_car_auth['info.channel'] : ''
            },
            channelColumns: function() {
                return Object.values(this.channelType)
            },
            channelValue: function() {
                return Object.keys(this.channelType).reduce((acc, key) => {
                    acc[this.channelType[key]] = key
                    return acc
                }, {})
            },
        }

    }
</script>

<style lang="scss" scoped>

    /deep/ .van-cell::after {
        border-bottom: 0px;
    }

    .resultPage {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        width: 100vw;
        height: 100vh;
    }
    .SubmitBtn {
        margin: 0;
        width: 75vw;
        border-radius: 0.3rem;
    }
    .GridSelected {
        background-color: rgb(253, 249, 183);
        border: 0.1rem solid rgb(250, 210, 81);
        border-radius: 0.3rem;
    }
    .UnGridSelected {
        border: 0.1rem solid rgba(250, 210, 81, 0);
        border-radius: 0.3rem;
    }
    .squareBox {
        display: inline-block;
        width: 85%;
        position: relative;
        vertical-align: middle;
        &:before {
            content:"";
            display: inline-block;
            padding-bottom: 100%;
            width: .1px;
            vertical-align: middle;
        }
    }
    .UploadImage {
        width: 80vw;
        height: 45vw;
        display:flex;
        justify-content: center;
        margin: auto;
        border: 0.1px solid rgb(177, 177, 177);
    }

    .UploadSpan {
        text-align: center;
        display:block;
        font-size: 0.4rem;
        color: #666;
        margin: 0.4rem;
    }
    .UploadInfo {
        text-align: center;
        display:block;
        font-size: 0.35rem;
        color: #999;
        margin: 0.2rem;
    }

    /deep/ .van-uploader__wrapper {
        width: 100%;
        height: 100%;
    }
    /deep/ .van-uploader__upload {
        margin: 0;
        height: 100%;
        width: 100%;
    }
    /deep/ .van-uploader__preview {
        margin: 0;
        height: 100%;
        width: 100%;
    }
    /deep/ .van-uploader__preview-image {
        height: 100%;
        width: 100%;
    }
    /deep/ .van-uploader__preview-delete {
        width: 1rem;
        height: 1rem;
    }
    /deep/ .van-uploader__preview-delete-icon {
        width: 0.6rem;
        height: 0.6rem;
        top: 0.08rem;
        left: 0.08rem;
        font-size: 1rem;
    }
    /deep/ .van-grid-item__content {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/Certification.vue